import { css } from 'styled-components';

export const halfWidth = css`
  display: inline-block;
  margin: 0;
  width: 50%;
  vertical-align: top;
`;

export const thirdWidth = css`
  display: inline-block;
  margin: 0;
  width: 33.3%;
  vertical-align: top;
`;
